module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "persistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.settings, "visible", $$v)
      },
      expression: "settings.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showCopyToOffices
    }
  }, [_c('v-list-item-title', [_vm._v("Copy to Offices")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.clientToClipboard
    }
  }, [_c('v-list-item-title', [_vm._v("Copy to Clipboard")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('CommunicationBar', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "expanded": "",
      "contact": _vm.elementAsContact
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px",
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "div-button display-flex clickable mr-2",
    on: {
      "click": _vm.clickedEditContact
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Edit " + _vm._s(_vm.firstName))]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "350",
      "color": "#888"
    }
  }, [_vm._v("Name, phone, email for every future transaction")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "div-button display-flex clickable mr-2",
    on: {
      "click": _vm.showElementDialog
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('div', [_c('b', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Change Association")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "350",
      "color": "#888"
    }
  }, [_vm._v("Role and comments for this transaction only")])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('DeleteButton', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "delete": function($event) {
        return _vm.unlinkContact(_vm.elementAsContact)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.refreshContact
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('ContactEditor', {
    attrs: {
      "settings": _vm.contactEditor.settings,
      "contactItem": _vm.contactEditor.contact
    },
    on: {
      "saved": _vm.contactSaved
    }
  }), _vm._v(" "), _c('OfficeSelectionDialog', {
    attrs: {
      "settings": _vm.officeSelectionDialog.settings
    },
    on: {
      "select": _vm.copyToOffices
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1ed547e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionContact.vue
// module id = 2646
// module chunks = 1